import { ReactComponent } from "./plus-fill.svg";

interface Props {
  style?: React.CSSProperties;
}

const PlusFillIcon: React.FC<Props> = (props) => <ReactComponent {...props} />;

export default PlusFillIcon;
